<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a :href="'/#/'">
            <i class="fa fa-home"></i>Home
          </a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">{{this.folderName}}</li>
      </ol>
    </nav>
    <div class="card">
      <div class="card-header">
        <div class="card-title">{{this.folderName}}</div>
      </div>
      <div class="card-body">
        <ul v-if="this.folderName === 'E-Library'" class="list-news">
          <li v-for="(folder,index) in folders.slice(startFiles,endFiles)" v-bind:key="index" >
            <a v-bind:href="'/#/folderdetail/'+folder.name">
              <div class="pic" style="background-image: url('img/bg_file.jpg')"></div>
              <div class="con">
                <div class="title">{{folder.name}}</div>
                <div class="text">{{$moment(folder.createdDateTime).format("YYYY-MM-DD HH:mm:ss") }}</div>
              </div>
            </a>
          </li>
        </ul>
        <ul v-if="this.folderName !== 'E-Library'" class="list-news">
          <li v-for="(folder,index) in folders.slice(startFiles,endFiles)" v-bind:key="index" >
            <!-- <a v-bind:href="'/#/NewsList/'+folderName+'/'+folder.fields.Category"> -->
            <a v-bind:href="'/#/NewsList/'+folderName+'/'+folder">
              <div class="pic" style="background-image: url('img/bg_list.jpg')"></div>
              <div class="con">
                <div class="title">{{folder}}</div>
                <div class="text">{{$moment(folder.createdDateTime).format("YYYY-MM-DD HH:mm:ss") }}</div>
              </div>
            </a>
          </li>
        </ul>
      </div>
      <div class="card-footer">
        <div class="func-tool">
          <div class="pagination-num">
            {{currenPage}}/{{getTotalPage}}
            <span>Total:{{total}}</span>
          </div>
          <ul class="pagination justify-content-center">
            <li class="page-item">
              <a class="page-link" v-on:click="getLastPage(currenPage)">
                <i class="fa fa-angle-left"></i>
              </a>
            </li>
            <li class="page-item" v-for="(page,index) in getTotalPage" v-bind:key="index">
              <a class="page-link"  v-on:click="getPagination(index)">{{index+1}}</a>
            </li>
            <li class="page-item">
              <a class="page-link" v-on:click="getNextPage(currenPage)">
                <i class="fa fa-angle-right"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'FolderList',
  data: () => ({
    startFiles: 0,
    endFiles: 15,
    numberPerPage: 15,
    currenPage: 1,
    total: 0,
    folderName: '',
    folders: []
  }),
  created () {
    this.folderName = this.$route.params.name
    if (this.folderName === 'E-Library') {
      this.getCrewPortalDocumentList(localStorage.getItem('access_token'))
        .then(resp => {
          this.folders = resp.data.value
          this.total = resp.data.value.length
        })
        .catch(err => {
          console.log('err', err)
        })
    } else {
      this.getCategory(localStorage.getItem('access_token'), this.GLOBAL.sharepoint['pilotportalsite_id'], this.folderName)
        .then(resp => {
          resp.data.value.forEach(item => {
            this.folders.push(item.fields.Category)
          })
          this.folders = [...new Set(this.folders)]
          this.total = this.folders.length
        })
        .catch(err => {
          console.log('err', err)
        })
    }
  },
  methods: {
    getUrl (newsobj) {
      if (newsobj.fields.Thumbnail === undefined) {
        return 'img/bg_file.jpg'
      } else {
        return newsobj.fields.Thumbnail.Url
      }
    },
    getPagination (page) {
      this.currenPage = page + 1
      this.startFiles = page * this.numberPerPage
      this.endFiles = (page + 1) * this.numberPerPage
    },
    getLastPage (page) {
      if (page > 1) {
        this.currenPage = page - 1
        this.startFiles = (page - 2) * this.numberPerPage + 1
        this.endFiles = (page - 1) * this.numberPerPage
      }
    },
    getNextPage (page) {
      if (page < this.getTotalPage) {
        this.currenPage = page + 1
        this.startFiles = page * this.numberPerPage
        this.endFiles = (page + 1) * this.numberPerPage
      }
    }
  },
  computed: {
    getTotalPage () {
      return Math.ceil(this.folders.length / this.numberPerPage) ? Math.ceil(this.folders.length / this.numberPerPage) : 1
    }
  }
}
</script>
